export class Hamburger {

    private element!:JQuery<HTMLElement>;
    private static burgers:Hamburger[]=[];

    constructor(e:JQuery<HTMLElement>|string) {
        if (typeof e=='string') e=$(e);
        if (e.length>1) {
            for (let ei of e) new Hamburger($(ei));
            return;
        }
        let existing=Hamburger.burgers.find(x=>x.element.is(e));
        if (existing) return existing;
        Hamburger.burgers.push(this);
        this.element=e;
        e.on("click",()=>this.onclick());
    }

    protected opened() {}
    protected closed() {}

    public open() {
        this.triggerAll('hamburger.open');
        var ham=$('.hamburger');
        ham.addClass('open')
        this.opened();
        ham.attr('aria-expanded',"true");
    }

    public close() {
        this.triggerAll('hamburger.close');
        var ham=$('.hamburger');
        ham.removeClass('open');
        this.closed();
        ham.attr('aria-expanded',"false");
    }

    private triggerAll(eventName:string) {
        $('*').each((idx,e) => {
            $(e).triggerHandler(eventName);
        });
    }

    public toggle() {
        var ham=$('.hamburger');
        if (ham.hasClass('open')) this.close(); else this.open();
    }

    private onclick() {
        this.toggle();
    }

}

export {};